export default __webpack_public_path__ + "static/media/timer.9a6ea995.svg";